<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button>
      <template #items>
        <b-dropdown-item @click="openColumnsModal">
          <feather-icon
              icon="CheckSquareIcon"
              size="16"
          />
          <span class="align-middle ml-50">{{ $t('columns.self') }}</span>
        </b-dropdown-item>
      </template>

    </breadcrumb-button>
    <!--Filters-->
    <filter-card v-model="filter" v-bind:fields="filterFields" search/>
    <!--Table Card-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{ $t('menu.userActivity') }}</h5>
      </b-card-header>
      <b-card-body>
        <userActivity-table ref="userActivityTable" v-bind:filters="filter" v-bind:columns="columns" :has-selection="false"
                       :lazy="true"/>
      </b-card-body>
    </b-card>
    <!--Modal-->
    <columns-modal ref="columns-modal" column-key="userActivity" v-model="columns"
                   v-bind:columns-names="columnsNames"
    />
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import BreadcrumbButton from '@/components/widget/breadcrumbButton';
import UserActivitySearchRequest from '@/model/tracker/TrackerSearchRequest';
import ColumnsModal from '@/components/modal/columnsModal';
import UserActivity from '@/model/tracker/Tracker';
import mixinPermissions from '@/components/mixin/mixinPermissions';
import mixinBase from '@/components/mixin/mixinBase';
import FilterCard from '@/components/widget/FilterCard';
import UserActivityFilterFields from '@/model/filter/UserActivityFilterFields';
import UserActivityTable from '@/components/tables/UserActivityTable';

export default {
  name: 'UserActivityView',
  components: {
    UserActivityTable,
    FilterCard,
    ColumnsModal,
    BreadcrumbButton,
  },
  mixins: [mixinBase, mixinPermissions],
  data() {
    return {
      columnsNames: Object.keys(UserActivity()),
      filter: UserActivitySearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    };
  },
  watch: { },
  async created() {
    this.filterFields = UserActivityFilterFields();
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
  },
  methods: {
    openColumnsModal() {
      this.$refs['columns-modal'].showModal();
    },

  }
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
  height: 10px;
}
</style>
